export enum FiservAuAcquirers {
  FiservAu = 'FISERV_AU',
  TillAu = 'TILL_AU',
}
